export function getDefaultLocaleCurrentDomain() {
  switch (window.location.hostname) {
    case 'beta.eu.learning.warehousejobs.in':
    case 'gamma.eu.learning.warehousejobs.in':
    case 'learning.warehousejobs.in':
    case 'localhost':
      return 'en-IN';
    default:
      return 'en-US';
  }
}
